import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo, useContext, useMemo, } from 'react';
import styleUtils from '../../styles/styleUtils';
import theme from '../../styles/theme';
import { PickerOptionInputStateContext } from '../../utils/InputStateContext';
const TransparentOverlay = () => {
    const { isDisabled, isHovering, } = useContext(PickerOptionInputStateContext);
    const overlayStyles = useMemo(() => (css `
        ${styleUtils.borderBox}
        background-color: transparent;
        height: 100%;
        width: 100%;

        ${(isHovering && !isDisabled) && css `
          background-color: ${theme.colors.gray800};
          opacity: 20%;
        `}

        @media (pointer: coarse) and (max-width: ${theme.breakpoints.small}) {
          display: none;
        }
      `), [
        isDisabled,
        isHovering,
    ]);
    return (_jsx("div", { css: overlayStyles }));
};
const MemoizedTransparentOverlay = memo(TransparentOverlay);
export { MemoizedTransparentOverlay as TransparentOverlay };
// MC-1068 Temporary hack for Storybook.
export default TransparentOverlay;
